import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24cf9736"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Actualiza Tarifas Refrigeración", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom01",
  class: "form-label"
}, "Entrada", -1))
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Peso Base", -1))
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Diario", -1))
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Mínimo", -1))
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "F Pallet", -1))
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Status", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Activo", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))

import { Ref, ref } from 'vue'
import axios from 'axios'
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpCarTari',
  props: {
    btnUp: Boolean,
    fecha_inicio: String,
    fecha_final: String,
    entrada: String,
    medida: String,
    peso_base: String,
    costo_diario: String,
    minimo_diario: String,
    full_pallet: String,
    status: String,
    id_ref: String

},
  emits: ['updateProps'],
  setup(__props, { emit: __emit }) {

const dUrl = UrlGlobal()

//props y emits ----------------------------------------------------------------
const props = __props
const emits = __emit
const handleClick = () => {
    emits("updateProps", !props.btnUp)
}
//------------------------------------------------------------------------------

//variables reactivas para el formulario----------------------------------------
const fecha_inicio = ref(props.fecha_inicio)
const entrada = ref(props.entrada)
const peso_base = ref(props.peso_base)
const costo_diario = ref(props.costo_diario)
const minimo_diario = ref(props.minimo_diario)
const full_pallet = ref(props.full_pallet)
const status = ref(props.status)
const id_ref = ref(props.id_ref)
//------------------------------------------------------------------------------

const handleSubmit = async () => {
    try {
        const response = await axios.post(dUrl.urlGlobal +'/api2/update/', {
            table: 'cartari', 
            filters: { tarifa: "03", fecha_inicio: fecha_inicio.value}, // Filtro para identificar el registro a actualizar
            data: { entrada: entrada.value, costo_diario: costo_diario.value, minimo_diario: minimo_diario.value,
                full_pallet: full_pallet.value, peso_base: peso_base.value, status: status.value } // Datos a actualizar
        })
        emits("updateProps", !props.btnUp)
    } catch (error) {
        console.error("Error actualizando datos:", error)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom01",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((entrada).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, entrada.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((peso_base).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, peso_base.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((costo_diario).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, costo_diario.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((minimo_diario).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, minimo_diario.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((full_pallet).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, full_pallet.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            id: "validationCustom04",
            required: "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((status).value = $event)),
            disabled: ""
          }, _hoisted_20, 512), [
            [_vModelSelect, status.value]
          ]),
          _hoisted_21
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: handleClick
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})